export default {
  getTgInviteLinkCpa: state => state.tgInviteLinkCpa,
  getMinAppUrl: state => state.minAppURL,
  getTgBtn: state => state.tgBtn,
}
